export const environment = {
  production: false,
  /** Email address that should receive the owner (Seamus) role on first login */
  ownerEmail: 'soconnor0812@icloud.com',
  firebase: {
    apiKey: 'AIzaSyAh0Vf6f-XFsvvpyiZFWSDaXqIuEm_0Lvk',
    authDomain: 'shea-services-dev.firebaseapp.com',
    projectId: 'shea-services-dev',
    storageBucket: 'shea-services-dev.firebasestorage.app',
    messagingSenderId: '585837757085',
    appId: '1:585837757085:web:83136beabc2934441a4a74',
    measurementId: 'G-5KQ0XL8D01',
  },
};
